export default __webpack_public_path__ + "static/media/Clarified Devilsmead.3cde280b.jpg";